import { INTAKE_FORMS_EMPTY_TABLE_TITLE } from '@/utils/constants'

/*
 * SCSS → Tailwind mapping (IntakeFormsEmptyTable.scss deleted):
 *   .intake-forms-empty-table-container:
 *     font-family Outfit         → font-sans (DS fontFamily.sans = Outfit)
 *     font-size: 14px            → text-size-3
 *     font-weight: 500           → font-medium
 *     color: --text-medium       → text-text-light (DS text.light = #253845B2 ≈ rgba(37,56,69,0.7))
 *     padding: 40px 24px         → py-sp-5 px-sp-3
 *     text-align: center         → text-center
 *     border-radius: 0 0 8px 8px → rounded-b-large
 */
export const IntakeFormsEmptyTable = () => (
  <div className='rounded-b-large px-sp-3 py-sp-5 text-center font-sans text-size-3 font-medium text-text-light'>
    {INTAKE_FORMS_EMPTY_TABLE_TITLE}
  </div>
)
